<template>
  <div class="container row big-box" id="navbar">
    <div class="container" id="left-nav">
      <router-link to="/">
        <img src="../assets/logo PO.png" alt="Logo PO Fasilkom" id="logo" />
      </router-link>
    </div>
    <div class="container" id="right-nav">
      <!-- <a href="/#home-section" class="body-nav">Home</a> -->
      <router-link to="/" class="body-nav">Home</router-link>
      <!-- <router-link to="/#about" class="body-nav">About</router-link> -->
      <a href="/#about" class="body-nav">About</a>
      <router-link to="/gallery" class="body-nav">Gallery</router-link>
    </div>
    <Slide right id="slide-bar">
      <router-link to="/" class="body-nav">Home</router-link>
      <a href="/#about" class="body-nav">About</a>
      <router-link to="/gallery" class="body-nav">Gallery</router-link>
    </Slide>
  </div>
</template>

<script>
import { Slide } from "vue-burger-menu";

export default {
  name: "NavBar",
  components: {
    Slide
  }
};
</script>

<style scoped>
#navbar {
  height: 100px;
  background-color: #ffd169;
  font-size: 22px;
  position: fixed;
  top: 0;
}

.body-nav {
  font-size: 22px;
  color: black;
  margin: 0px 2vw;
}

#slide-bar {
  display: none;
}

#right-nav {
  justify-content: flex-end;
  margin-right: 5vw;
  width: 50%;
}

#left-nav {
  justify-content: flex-start;
  width: 50%;
  margin-left: 3vw;
}

#logo {
  width: 159px;
  height: auto;
}

@media screen and (max-width: 600px) {
  #navbar {
    height: 80px;
  }

  .body-nav {
    margin: 0px;
  }

  #right-nav {
    visibility: hidden;
  }

  #slide-bar {
    display: flex;
  }

  #logo {
    width: 30vw;
  }
}
</style>
